export default {
    "data":{
        "h5" :{
            "imgList":[
                "https://s20.lgstatic.com/growth/activity/20210601/1622513147143.png",
                "https://s20.lgstatic.com/growth/activity/20210531/1622444076790.png",
                "https://s20.lgstatic.com/growth/activity/20210531/1622444089941.png",
                "https://s20.lgstatic.com/growth/activity/20210531/1622444154803.png",
                "https://s20.lgstatic.com/growth/activity/20210531/1622444179947.png",
                "https://s21.lgstatic.com/growth/activity/20210531/1622444209837.png",
                "https://s20.lgstatic.com/growth/activity/20210531/1622444247519.png",
                "https://s21.lgstatic.com/growth/activity/20210531/1622444285996.png",
                "https://s20.lgstatic.com/growth/activity/20210531/1622444313788.png",
                "https://s20.lgstatic.com/growth/activity/20210531/1622444357771.png",
                "https://s21.lgstatic.com/growth/activity/20210531/1622444379211.png",
                "https://s21.lgstatic.com/growth/activity/20210531/1622444401416.png"
            ],
            "footer":"https://s21.lgstatic.com/growth/activity/20210528/1622186293542.png"
        },
        "pc": {
            "imgList":[
                "https://s21.lgstatic.com/growth/activity/20210615/1623737903926.png",

                "https://s21.lgstatic.com/growth/activity/20210615/1623737936326.png",

                "https://s21.lgstatic.com/growth/activity/20210615/1623737975584.png",
                "https://s20.lgstatic.com/growth/activity/20210615/1623738051552.png",
                "https://s21.lgstatic.com/growth/activity/20210615/1623738076315.png",

                "https://s21.lgstatic.com/growth/activity/20210615/1623738097198.png",

                "https://s20.lgstatic.com/growth/activity/20210615/1623738125418.png",
                "https://s20.lgstatic.com/growth/activity/20210615/1623738152963.png",
                "https://s21.lgstatic.com/growth/activity/20210615/1623738175088.png",
                "https://s20.lgstatic.com/growth/activity/20210615/1623738186981.png",
                "https://s21.lgstatic.com/growth/activity/20210615/1623738221817.png",
                "https://s21.lgstatic.com/growth/activity/20210615/1623738233124.png",
                "https://s21.lgstatic.com/growth/activity/20210615/1623738243758.png",
                "https://s20.lgstatic.com/growth/activity/20210615/1623738255614.png",
                "https://s21.lgstatic.com/growth/activity/20210615/1623739340047.png"
            ],
            "footer":"https://s20.lgstatic.com/growth/activity/20210615/1623738271203.png",
        }
    }
}